/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminLoginRequest
 */
export interface AdminLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminLoginRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminLoginRequest
     */
    password?: string;
}

/**
 * Check if a given object implements the AdminLoginRequest interface.
 */
export function instanceOfAdminLoginRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdminLoginRequestFromJSON(json: any): AdminLoginRequest {
    return AdminLoginRequestFromJSONTyped(json, false);
}

export function AdminLoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminLoginRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function AdminLoginRequestToJSON(value?: AdminLoginRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
    };
}

